import qrcode from '@/components/qr-code'

export default {
  name: 'qr-code',
  components: {qrcode},
  props: [],
  data () {
    return {
    }
  },
  computed: {

  },
  mounted () {

  },
  methods: {

  }
}



// WEBPACK FOOTER //
// ./src/views/qr-code/qr-code.js